import React, { useMemo, useState, useEffect } from 'react';
import { useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Header, Text } from '../../components/index';

import { MessageListWindow } from '../../components/Message/MessengerWindow';
import ChatWindow from '../../components/Message/ChatWindow';

import { GET_PATIENT_MESSAGES } from '../../services/patient';
import { alertError, setMessagesReceiver } from '../../redux/stateActions';
import { decrypt } from '../../utils/messages';

import { patientPageWidth } from '../../constant';

import { readMessage } from '../../services';

import socket from '../../socket';

const Message = ({ history }) => {
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('md'));

    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);

    const patientId = useMemo(() => {
        if (!_.isEmpty(user)) {
            const findPatient = user.patient;
            if (findPatient) {
                return findPatient.id;
            }
        }
        return null;
    }, [user]);

    const [refetchMesssgeCount, setRefetchMesssgeCount] = useState(0);

    /*---------- Messenger Window ----------*/
    const [open, setOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [messagesData, setMessagesData] = useState([]);

    const {
        data: getMessagesData,
        error: getMessagesError,
        refetch: getMessageRefetch,
    } = useQuery(GET_PATIENT_MESSAGES, {
        variables: { id: patientId },
        skip: _.isEmpty(user) || !patientId,
    });
    useEffect(() => {
        if (getMessagesError) {
            dispatch(alertError(`Cannot get Messages: ${getMessagesError.message}`));
        }

        if (getMessagesData) {
            const decryptMessages = getMessagesData.patient.messages.map((message) =>
                message.text
                    ? {
                          ...message,
                          isRead: message.senderRole === 'Patient' ? true : message.isRead,
                          text:
                              !message?.staff?.id || !message?.patient?.id
                                  ? 'text unavailable'
                                  : decrypt(
                                        message.text,
                                        ['Provider', 'Provider Admin', 'Admin'].includes(
                                            message.senderRole
                                        )
                                            ? message.staff.id + message.patient.id
                                            : message.patient.id + message.staff.id
                                    ),
                      }
                    : {
                          ...message,
                          isRead: message.senderRole === 'Patient' ? true : message.isRead,
                      }
            );

            if (searchValue === '') {
                setMessagesData(decryptMessages);
            } else {
                const filteredDecryptMessages = decryptMessages.filter((data) =>
                    data.staff?.user?.fullname.toLowerCase().includes(searchValue.toLowerCase())
                );
                setMessagesData(filteredDecryptMessages);
            }
        }
    }, [getMessagesError, getMessagesData, searchValue]);

    const onClick = async (data) => {
        dispatch(setMessagesReceiver(data));
        setOpen(true);

        if (data.senderRole === 'Patient' || data.isRead === true) return;

        try {
            const res = await readMessage(data.messageId);

            if (res.status === 200) {
                getMessageRefetch();
                setRefetchMesssgeCount(refetchMesssgeCount + 1);
            } else {
                throw new Error(res);
            }
        } catch (error) {
            dispatch(alertError(`cannot update message: ${error.message}`));
        }
    };

    useEffect(() => {
        socket.on('newMessage', () => {
            getMessageRefetch();
        });
    }, []);

    return (
        <div
            style={{
                margin: '0 15px 0',
                width: '100%',
                maxWidth: patientPageWidth,
                position: 'relative',
                height: '100%',
                display: 'grid',
                gridTemplateRows: 'auto 1fr',
                maxHeight: '100vh',
            }}
        >
            <Header
                showMessage
                showNotice
                showGoBack1
                onClickGoBack={() => history.goBack()}
                style={{ maxWidth: patientPageWidth, padding: '0 15px' }}
                childrenContainerStyle={{ textAlign: 'center' }}
                refetchMesssgeCount={refetchMesssgeCount}
            >
                <Text $fontSize="20px" $medium>
                    Message
                </Text>
            </Header>
            <div
                style={{
                    backgroundColor: 'white',
                    paddingBottom: lg ? 0 : '75px',
                    overflowY: 'scroll',
                }}
            >
                <MessageListWindow
                    value={searchValue}
                    onChange={setSearchValue}
                    data={messagesData}
                    onClick={onClick}
                    myRole="patient"
                    $width="100%"
                />
            </div>
            <ChatWindow fullScreen={true} open={open} setOpen={setOpen} />
        </div>
    );
};

Message.propTypes = {
    history: PropTypes.object,
};

export default Message;
